import React, { createContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [role, setRole] = useState(localStorage.getItem('role') || '');
  const [id, setId] = useState(localStorage.getItem('id') || '');
  const [username, setUsername] = useState(localStorage.getItem('username') || '');

  const [isAdminRegistered, setIsAdminRegistered] = useState(true);


  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        const response = await authAPI.checkAdmin();
        setIsAdminRegistered(response.data.isAdminRegistered);
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdminRegistered(false); // Assume no admin if check fails
      }
    };
    checkAdminStatus();
  }, []);

  const logout = () => {
    setToken('');
    setRole('');
    setId('');
    setUsername('');
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('id');
    localStorage.removeItem('username');
  };

  return (
    <AuthContext.Provider value={{ token, setToken, role, setRole, isAdminRegistered, logout, id, setId, username, setUsername }}>
      {children}
    </AuthContext.Provider>
  );
};